<template lang="pug">
  b-container.h-custom(fluid)
    tutorial-modal(view="Productos")
      template(v-slot:default)
        b-container
          p Aquí puedes subir los productos que venderá el Chatbot. Cada producto se le puede agregar:
          ul
            li Nombre y descripción
            li Costo
            li Inventario disponible para venta. Cuando llega a 0 deja de ofrecerlo a tus clientes.
            li Foto (de preferencia de 760px largo x 400px alto)
            li Keywords o palabras clave (ayudan a la búsqueda de productos)
            li Prioridad indica qué productos se deben mostrar primero (mayor prioridad se muestra primero)
          h5 Categorías
          p El Chatbot ofrecerá todos tus productos en una galería al inicio. Puedes agrupar los productos por categoría y primero mostrará las categorías disponibles y después los productos de la categoría seleccionada.
          p Para asociar tus productos a una categoría da click en Asociar productos o al abrir un producto puedes seleccionar las categorías a las que pertenece:
          b-img.mb-3(src="@/assets/tutorial/products-buttons.png", fluid, rounded, center, width="400")
          h5 Compartir productos
          p Puedes redirigir a tus clientes a un producto en específico en el chat compartiendo un link mágico que se genera para cada producto. Solo da click sobre botón Compartir y copia el link de la plataforma que deseas enviar:
          b-img.mb-3(src="@/assets/tutorial/products-link.png", fluid, rounded, center)
          //h5 Variantes de productos
            p.mb-0 Puedes crear variantes de un mismo producto y asignarle valores a cada tipo de variante.
            p.mb-0 Ejemplo de una variante de producto: Color.
            p Valores para la variante de color: Rojo, Azul, Verde, etc.
            p Al precio del producto se le sumará el precio del valor de la variante elegida por el usuario.
          h5 Subir productos desde un archivo
          p Agrega los datos de tus productos en la columna correspondiente de la plantilla. Toma en cuenta las siguientes consideraciones.
          ul
            li El nombre es un dato requerido.
            li Para la Cantidad disponible y el Precio ingresa solo el valor.
            li El ID externo es un dato que tu ocupes para identificar tu producto
            li El Peso utiliza medidas de Kilogramo (Km)
            li El Largo, Ancho, Alto utiliza medidas de metro (m)
            li Imagen, ingresa la URL de una aimgen para agregarla la producto
            li Categorías, agrega el nombre(s) de las categorías de tus productos separadas por / (diagonal).
            li Subcategorías, agrega el nombre(s) de las subcategorías de tus productos separadas por / (diagonal).
          b-img.mb-3(src="@/assets/tutorial/upload-productos.png", fluid, rounded, center)

    b-form-row.align-items-center.justify-content-between.mt-3.mb-4
      b-col.mb-2.mb-md-0
        b-row.d-flex.align-items-center.justify-content-between
          h4.mb-0.mr-4 Productos
          b-button.mr-3(variant="an", :to="{ name: 'Products Package' }") Paquetes de productos
      b-col.mb-2.mb-md-0(md="auto")
        b-button(variant="an", @click="canCreateProducts", :disabled="creatingProd")
          span Crear producto
          b-spinner.ml-2(small v-if='creatingProd')
      //- b-col(md="auto")
      //-   b-button(variant="soft-primary", @click="openCategoriesModal", :disabled="!all_products.length") Asociar productos
      b-col(cols="auto")
        b-dropdown(right, variant="light", :menu-class="['filters-dropdown']", no-caret, dropleft, :disabled="creatingProd")
          template(slot="button-content")
            more-vertical-icon.icon-sm
          b-dropdown-item(@click="upload_products_modal = true")
            upload-icon.icon-sm.mr-2
            span Subir productos desde un archivo
          b-dropdown-item(@click="upload_update_modal = true")
            upload-icon.icon-sm.mr-2
            span Actualizar productos desde un archivo
          b-dropdown-item(@click.stop="downloadGuide")
            download-icon.icon-sm.mr-2
            span Descargar plantilla
            p.mb-0.text-secondary.text-sm.text-wrap La plantilla contiene la estructura necesaria para subir productos desde archivo. Si tienes alguna duda puedes revisar el tutorial
    b-row.h-100
      b-col.h-100.overflow-md-y.scrollable-area.d-flex.flex-column(lg="4")
        b-card(no-body)
          b-container.px-0.overflow-y.scrollable-area(fluid)
            div(style="color:#6e84a3;background-color:#f9fbfd;padding:12px 24px;border-bottom:1px solid #edf2f9;")
              span.font-weight-bold Categorías
            .d-flex.justify-content-between.align-items-center.px-4.py-3.pointer(:class="{'background-secondary': $route.name == 'ProductsList' && $route.params.category_id == 'all'}", @click="selectAll(true)")
              p.mb-0 Todos los productos
                span.text-help.text-sm.ml-1 ({{total_products}})
              chevron-right-icon
            b-table.card-table.mb-0(ref="categories_table", :fields="categories_fields", :items="parsed_categories", responsive, show-empty, :busy="loading", selectable, select-mode="single", selectedVariant="white", @row-selected="selectCategory")
              template(v-slot:empty)
                p.mb-0.text-center.text-help {{search_text.length ? 'No hay conincidencias' : 'No has creado categorías'}}
              template(v-slot:table-busy)
                .text-center
                  b-spinner(variant="primary")
              template(v-slot:cell(name)="{ item }")
                div
                  .d-flex.align-items-center.p-2(style="border-radius:5px;" :style="{background: $route.params.category_id == item.category_id ? '#d6dde5' : ''}")
                    b-img.mr-2(:src="item.image", :blank="!item.image || item.error", @error="item.error = true", blank-color="#f2f2f2", rounded, width="50", height="50")
                    div(style="flex: 1;")
                      p.mb-0 {{ item.name }}
                        span.text-help.text-sm.ml-1 ({{item.products_count}})
                      p.mb-0.text-secondary.text-sm {{ item.description }}
                    chevron-right-icon
                  b-collapse(v-if="item.Children && item.Children.length" :visible="!isNaN($route.params.category_id) && $route.params.category_id == item.category_id || item.Children.map(c => c.category_id).includes($route.params.category_id)" @click.stop)
                    .pt-3
                    .d-flex.align-items-center.justify-content-between.mb-0.p-2.pointer(v-for="child in item.Children" :key="child.category_id" style="border-radius:5px;" @click.stop="selectCategory([child])" :class="$route.params.category_id == child.category_id ? 'text-primary' : null" :style="{background: $route.params.category_id == child.category_id ? '#d6dde5' : ''}")
                      span {{ child.name }}
                      chevron-right-icon.icon-sm
        div
          b-button(variant="primary", @click="$router.push({name: 'Products Categories' }).catch(() => {})")
            .d-flex.align-items-center.justify-content-between
              span Editar categorías
              chevron-right-icon.icon-sm
      b-col#product-container.h-100.overflow-md-y(v-if="$breakpoint.lgUp")
        .p-3(v-if="$route.name == 'Categories'")
          h4.text-center.text-secondary Selecciona una categoría para ver productos
        router-view(@select-product="openProductModal")
    SideModal(v-model="side_modal_products", size="lg", @input="!$event ? selectAll(false) : false")
      template(v-if="side_modal_products")
        router-view.full-height(:border="false", @select-product="openProductModal")
    b-modal(v-model="categories_modal", title="Asociar productos", centered, ok-title="Aplicar", ok-variant="primary", cancel-title="Cancelar", @ok="associateProducts", :ok-disabled="loading_categories || !category_to_associate", no-close-on-backdrop)
      b-form-group(label="Categoría a la que asociarán los productos:")
        b-form-select(v-model="category_to_associate")
          option(:value="null" disabled) -- Seleccionar categoría --
          option(v-for="category in categories_list", :key="category.value", :value="category.value") {{ category.text }}
      b-form-group(label="Selecciona los productos que quieres asociar:")
        p.text-secondary Solo los productos seleccionados se asociarán a la categoría elegida.
        b-form-checkbox.text-truncate(:indeterminate="indeterminate", @change="toggleAllSelected", :checked="all_checked")
          span.text-secondary Seleccionar todo
      b-form-group.overflow-y.scrollable-area(style="max-height: 250px")
        b-form-checkbox.mb-1(v-for="product_checkbox in all_products", :key="product_checkbox.product_id", :checked="selected_products.includes(product_checkbox.product_id)", @change="toggleProductSelected($event, product_checkbox.product_id)")
          .d-flex.align-items-start
            b-img.mr-2(:src="product_checkbox.image", v-if="product_checkbox.image && !product_checkbox.error", @error="product_checkbox.error = true", width="30", height="30", rounded="circle")
            p.mb-0 {{product_checkbox.name}}
    b-modal(title="Subir productos desde un archivo", v-model="upload_products_modal", ok-only, ok-title="Cerrar", ok-variant="secondary", size="lg")
      p.mb-0 Para cargar productos desde un archivo, debes subir un documento de hoja de calculo (.xls/.xlsx).
      p Te recomendamos descargar la plantilla de muestra.
      ul
        li IMPORTANTE: Las imágenes de tus productos deben contar con una URL, es decir, encontrarse en alguna página para obtener el enlace.
        li El nombre es un dato obligatorio. Asegúrate que sea claro y conciso.
        li Para la cantidad disponible y el precio ingresa solo el valor.
        li El ID externo es un dato que utilizas para identificar tu producto.
        li El peso debe ser expresado en kilogramos (kg). Si tu producto pesa gramos utiliza un "punto" antes del valor. Ejemplo: ﻿.50.
        li El valor de largo, ancho y alto debe ser expresado en centímetros (cm).
        li Si tu producto corresponde a más de una categoría deben ser reparadas por una diagonal (/). Ejemplo: ﻿Categoría 01 / Categoría 02
        li Si tu producto corresponde a más de una subcategoría deben ser reparadas por una diagonal (/). Ejemplo: ﻿Subcategoría 01 / ﻿Subcategoría 02
      b-form-group(label="Subir archivo", description="Da click en Seleccionar o arrastra un archivo para subirlo")
        b-form-row.align-items-center
          b-col
            b-form-file(placeholder="Selecciona un archivo en tu equipo", drop-placeholder="Suelta el archivo aquí...", v-model="upload_products_file", accept=".xls,.xlsx,.csv", browse-text="Seleccionar", :state="Boolean(upload_products_file) ? true : null")
          b-col(cols="auto")
            b-button(variant="primary", :disabled="!upload_products_file", @click="uploadProductsFile")
              span Subir archivo
              b-spinner.ml-2(small v-if='creatingProd')
    b-modal(title="Actualizar productos desde un archivo", v-model="upload_update_modal", ok-only, ok-title="Cerrar", ok-variant="secondary", size="lg")
      p.mb-0 Para cargar productos desde un archivo, debes subir un documento de hoja de calculo (.xls/.xlsx).
      ul
        li IMPORTANTE: El archivo debe contener los siguientes datos en las celdas la primera fila. Estos son los datos que se actualizarán del producto
        li product_id
        li name
        li sku
        li image (URL de la imagen)
        li description
        li stock (solo el valor)
        li price (solo el valor)
      b-form-group(label="Subir archivo", description="Da click en Seleccionar o arrastra un archivo para subirlo")
        b-form-row.align-items-center
          b-col
            b-form-file(placeholder="Selecciona un archivo en tu equipo", drop-placeholder="Suelta el archivo aquí...", v-model="upload_update_file",  :disabled="loading", accept=".xls,.xlsx,.csv", browse-text="Seleccionar", :state="Boolean(upload_update_file) ? true : null")
          b-col(cols="auto")
            b-button(variant="primary", :disabled="!upload_update_file || loading", @click="uploadUpdateFile")
              span Subir archivo
              b-spinner.ml-2(small v-if='loading')
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { UploadFile } from '@/helpers/upload-file'
import { toBase64 } from '@/helpers/file-converter'
import TutorialModal from '@/components/TutorialModal.vue'
import Download from 'downloadjs'
import readXlsxFile from 'read-excel-file'

const categoryController = createNamespacedHelpers('category')
const productController = createNamespacedHelpers('product')
const accountController = createNamespacedHelpers('account')
const API_URL = process.env.VUE_APP_API

export default {
  data: () => {
    return {
      loading: false,
      search_text: '',
      side_modal_products: false,
      categories_fields: [
        {
          key: 'name',
          label: '',
          thStyle: {
            display: 'none'
          }
        },
      ],
      loading_categories: false,
      product_modal: false,
      file: null,
      product: {
        product_id: null,
        name: '',
        description: '',
        image: '',
        price: '',
        stock: 0,
        enabled: true,
        priority: 0,
        keywords: '',
        categories: [],
        external_id: '',
        sku: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        hide: false,
        validated: false
      },
      pending_categories: [],
      loading_product: false,
      categories_modal: false,
      all_checked: false,
      indeterminate: false,
      selected_products: [],
      category_to_associate: null,
      upload_products_modal: false,
      upload_products_file: null,
      upload_update_modal: false,
      upload_update_file: null,
      creatingProd: false,
      total_products: 0
    }
  },
  computed: {
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    ...productController.mapState({
      all_products: state => state.all_products
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    parsed_categories () {
      let self = this
      return this.categories.map(c => {
        c.products_count = self.all_products.length ? (self.all_products.filter(p => p.categories.includes(c.category_id)).length || 0) : 0
        return c
      })
    },
    isUpdate () {
      return Boolean(this.product.product_id)
    },
    categories_list () {
      return this.categories.map(c => {
        return {
          text: c.name,
          value: c.category_id
        }
      })
    },
    showMissingValuesMessage () {
      return this.product.validated && (!this.product.name || !this.isPriceOk)
    },
    isPriceOk () {
      return parseFloat(this.product.price) >= 0
    },
    current_categories () {
      return this.product.product_id ? this.product.categories : this.pending_categories
    },
    measures_requiered () {
      return false
    },
  },
  methods: {
    // request group conversations here
    ...mapActions(['category/all', 'product/all', 'product/create', 'product/update', 'product/destroy', 'product/assignCategory', 'product/removeCategory', 'product/get', 'product/upload', 'product/update_upload', 'helpers/upload_file', 'helpers/upload_private_file']),
    getAllProducts() {
      let self = this
      this['product/all']({
        account_id: self.$route.params.account_id,
        list_all: true,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.total_products = res.total
          }
        }
      })
    },
    getCategories () {
      let self = this
      this.loading = true

      this['category/all']({
        account_id: self.$route.params.account_id,
        params: {
          relationship: 'parent',
          limit: 100
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$nextTick(() => {
              let index = self.parsed_categories.findIndex(c => c.category_id == self.$route.params.category_id)
              if(index >= 0)
                self.$refs.categories_table.selectRow(index)
            })
          }
        }
      })
    },
    async createProduct () {
      this.creatingProd = true
      this['product/create']({
        account_id: this.$route.params.account_id,
        enabled: true,
        callback: res => {
          this.creatingProd = false
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Producto creado correctamente')
            let created_id = res.resource.product_id
            this.$router.push({name: 'Product', params: { product_id: created_id } }).catch(() => {})
          }
        }
      })
    },
    deleteProduct (product) {
      var self = this
      this['product/destroy']({
        account_id: self.$route.params.account_id,
        ...product,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Producto eliminado')
            self.product_modal = false
          }
        }
      })
    },
    async updateProduct (modal, product) {
      //if (modal && modal.preventDefault) modal.preventDefault()

      product.validated = false

      if (modal && (!product.name || !this.isPriceOk)) {
        product.validated = true
        modal.preventDefault()
        return
      }

      var self = this
      this.loading_product = true

      if (this.file) {
        try {
          this.image_file = await UploadFile.call(this, this.file)
          product.image = this.image_file
        } catch (e) {
          console.log(e);
          self.$message.error('Error subiendo imagen')
          this.loading_product = false
          return
        }
      }

      this['product/update']({
        account_id: self.$route.params.account_id,
        ...product,
        callback: res => {
          self.loading_product = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Producto actualizado')
            self.product_modal = false
          }
        }
      })
    },
    clearImage () {
      this.product.image = ''
      this.file = null
    },
    confirmDeleteProduct (product) {
      let self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar el producto ${product.name}? No se puede deshacer.`, {
        title: 'Eliminar producto',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
      .then(value => {
        if (value == true) {
          self.deleteProduct(product)
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    openProductModal (product) {
      // this.file = null
      // this.clearObject(this.product, {boolean: true})
      // this.product.account_id = this.$route.params.account_id
      // this.product.price = ''
      // this.pending_categories = []
      // this.product.hide = false
      // if (product) {
      //   this.product = Object.assign(this.product, product)
      //   this.product.validated = false
      // }

      // if (this.product.Categories)
      //   this.product.categories = this.product.Categories.map(c => c.category_id)

      // this.product_modal = true

      this.$router.push({name: 'Product', params: { product_id: product.product_id, ...this.$route.params } }).catch(() => {})
    },
    async imagePicked (event) {
      let file = event.target.files[0]
      this.product.image = URL.createObjectURL(file)
      this.file = file
    },
    async uploadFile (file) {
      let self = this
      return new Promise (async (resolve, reject) => {
        let params = {
          file_name: file.name,
          mime: file.type
        }

        try {
          if (file.name.includes('.'))
            params.file_extension = file.name.split('.').slice(-1)
        } catch (e) {
          console.log(e.message)
        }

        try {
          let fileBase64 = await toBase64(file, true)
          params.file = fileBase64
        } catch (e) {
          console.log(e.message)
          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: res => {
            if (res.error) {
              reject(new Error(res.error))
            } else {
              resolve(res.resource.url)
            }
          }
        })
      })
    },
    modifyCategories (categories) {
      if (!this.product.product_id) {
        this.pending_categories = categories
        return
      }
      let self = this

      let current_categories = this.product.categories

      if (current_categories.length > categories.length) {
        let changed = current_categories.diff(categories)
        this.removeCategory(changed[0], this.product.product_id)
      } else {
        let changed = categories.diff(current_categories)
        this.assignCategory(changed[0], this.product.product_id)
      }
    },
    changeCategories (category_id) {
      let index = this.current_categories.findIndex(c => c == category_id)
      if(index >= 0) {
        this.product.product_id ? this.removeCategory(category_id, this.product.product_id) : this.current_categories.splice(index, 1)
      } else {
        this.product.product_id ? this.assignCategory(category_id, this.product.product_id) : this.current_categories.push(category_id)
      }
    },
    assignCategory (category_id, product_id, silent) {
      let self = this
      this.loading_categories = true

      this['product/assignCategory']({
        product_id: product_id,
        category_id: category_id,
        callback: res => {
          self.loading_categories = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (!silent)
              self.product.categories.push(category_id)
            self.getAllProducts()
          }
        }
      })
    },
    removeCategory (category_id, product_id) {
      let self = this
      this.loading_categories = true

      this['product/removeCategory']({
        product_id: product_id,
        category_id: category_id,
        callback: res => {
          self.loading_categories = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let index = self.product.categories.findIndex(c => c == category_id)
            if (index >= 0) self.product.categories.splice(index, 1)
            self.getAllProducts()
          }
        }
      })
    },
    openCategoriesModal () {
      this.category_to_associate = this.$route.params.category_id != 'all' ? this.$route.params.category_id : null
      this.categories_modal = true
    },
    toggleAllSelected (checked) {
      this.selected_products = checked ? this.all_products.map(p => {
        return p.product_id
      }) : []
    },
    associateProducts () {
      let self = this

      this.all_products.forEach(p => {
        if (self.selected_products.includes(p.product_id)) {
          if(!p.categories.includes(self.category_to_associate)) {
            self.assignCategory(self.category_to_associate, p.product_id)
          }
        } else {
          if(p.categories.includes(self.category_to_associate)) {
            self.removeCategory(self.category_to_associate, p.product_id)
          }
        }
      })

      this.categories_modal = false
      this.category_to_associate = null
    },
    toggleProductSelected (event, product_id) {
      if(event) {
        this.selected_products.push(product_id)
      } else {
        let index = this.selected_products.findIndex(p => p == product_id)
        if (index >= 0) this.selected_products.splice(index, 1)
      }
    },
    selectAll (open_sidemodal) {
      this.$refs.categories_table.clearSelected()
      this.$router.push({name: 'ProductsList', params: { category_id: 'all' } }).catch(() => {})
      this.side_modal_products = this.$breakpoint.mdDown && !!open_sidemodal
    },
    selectCategory (items) {
      if(items && items.length)
        this.$router.push({name: 'ProductsList', params: { category_id: items[0].category_id } }).catch(() => {})
    },
    canCreateProducts () {
      this.$router.push({name: 'Product', params: {product_id: 'new'} })
    },
    async uploadProductsFile () {
      try {
        this.creatingProd = true
        this.loading = true
        let uploaded_file_name = await UploadFile.call(this, this.upload_products_file, 'name', true)
        let self = this

        this['product/upload']({
          account_id: self.$route.params.account_id,
          file_name: uploaded_file_name,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.creatingProd = false
              self.loading = false
              self.upload_products_modal = false
              self.upload_training_file = null
              self.$message.success('Productos cargados correctamente')
              self.getCategories()
              self.getAllProducts()
            }
          }
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async downloadGuide () {
      try {
        var x=new XMLHttpRequest();
        x.open( "GET", "https://downloadable-files-konverza.s3.us-west-2.amazonaws.com/Subir_Productos.xlsx" , true);
        x.responseType="blob";
        x.onload= function (e) {
          Download(e.target.response, "Subir_productos.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        };
        x.send();
      } catch (e) {
        this.progress = 0
        console.error(e)
      }
    },
    async uploadUpdateFile () {
      let self = this
      this.loading = true
      let schema = {
        'product_id': { prop: 'product_id' },
        'name': { prop: 'name' },
        'sku': { prop: 'sku' },
        'image': { prop: 'image' },
        'description': { prop: 'description' },
        'stock': { prop: 'stock' },
        'price': { prop: 'price' },
      }
      let { rows, errors } = await readXlsxFile(this.upload_update_file, {schema: schema})
      if(errors && errors.length) {
        console.error("errors ", errors)
        this.$message.error("Ocurrió un error con el archivo seleccionado")
        return
      }

      this['product/update_upload']({
        account_id: self.$route.params.account_id,
        products: rows,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.loading = false
            self.upload_update_modal = false
            self.upload_update_file = null
            self.$message.success('Productos actualizados')
            self.getAllProducts()
          }
        }
      })
    }
  },
  components: {
    TutorialModal
  },
  created() {
    if (!this.$route.params.category_id) {
      this.$router.push({ name: 'ProductsList', params: { category_id: 'all' } })
    }
  },
  mounted () {
    this.getAllProducts()
    this.getCategories()

    if (this.$route.name != 'ProductsList') {
      this.$router.push({name: 'ProductsList', params: {category_id: 'all'}})
    }
  },
  watch: {
    '$breakpoint' (value) {
      if (value.lgUp) {
        this.side_modal_products = false
      }

      if (value.mdDown && this.$route.name == 'ProductsList') {
        this.side_modal_products = true
      }
    },
    '$route' (value) {
      if (value.name == 'ProductsList' && value.params.category_id && value.params.category_id != 'all' && this.$breakpoint.mdDown) {
        this.side_modal_products = true
      } else {
        this.side_modal_products = false
      }

      if (value.name == 'Categories') {
        this.$router.push({name: 'ProductsList', params: {category_id: 'all'}})
      }
    },
    category_to_associate (val) {
      this.selected_products = val ? this.all_products.filter(p => p.categories.includes(parseInt(val))).map(p => {
        return p.product_id
      }) : []
    },
    selected_products (val) {
      if (val.length == this.all_products.length) {
        this.all_checked = !!this.all_products.length
        this.indeterminate = false
      } else if (val.length > 0 && val.length < this.all_products.length) {
        this.all_checked = false
        this.indeterminate = true
      } else {
        this.all_checked = false
        this.indeterminate = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .h-custom {
    height: calc(100% - 78px - 38px);
  }

  .background-secondary {
    background-color: #d6dde5;
  }
</style>
